import { AppThunk } from '@/store'
import { request } from '@/store/actions'

import {
  FETCH_ACTIVE_NOW,
  FETCH_CHAT_ACTIVITY,
  FETCH_CONNECTOR_ACTIVITY,
  FETCH_SPACE_ENGAGEMENT_ANALYTICS,
  FETCH_SYSTEM_CONNECTOR_ACTIVITY
} from './actionTypes'

export const fetchConnectorActivityMetrics = (params: { oldest: string; latest: string }): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/connectors?oldest=${params.oldest}&latest=${params.latest}`,
        FETCH_CONNECTOR_ACTIVITY,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}

export const fetchActiveNowMetrics = (): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/engagednow`,
        FETCH_ACTIVE_NOW,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}

export const fetchChatMetrics = (params: { oldest: string; latest: string; difference?: string }): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/chatactivity?&oldest=${params.oldest}&latest=${params.latest}${
          params.difference ? `&difference=${params.difference}` : ''
        }`,
        FETCH_CHAT_ACTIVITY,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}

export const fetchSystemConnectorsMetrics = (params: {
  oldest: string
  latest: string
  difference?: string
}): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/systemconnectors?oldest=${params.oldest}&latest=${params.latest}${
          params.difference ? `&difference=${params.difference}` : ''
        }`,
        FETCH_SYSTEM_CONNECTOR_ACTIVITY,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}

export const fetchEngagementAnalyticsMetrics = (params: {
  interval: string
  oldest: string
  latest: string
  difference?: string
}): AppThunk => {
  return dispatch =>
    dispatch(
      request(
        `/analytics/spaces/:spaceId/engagementactivity?interval=${params.interval}&oldest=${params.oldest}&latest=${
          params.latest
        }${params.difference ? `&difference=${params.difference}` : ''}`,
        FETCH_SPACE_ENGAGEMENT_ANALYTICS,
        {},
        { args: { spaceId: ':spaceId' }, service: 'audit' }
      )
    )
}
